var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEmail)?_c('email-message',{attrs:{"message":_vm.object}}):(_vm.isSms)?_c('sms-message',{attrs:{"message":_vm.object}}):_c('internal-message',{attrs:{"message":_vm.object}})}
var staticRenderFns = []

export { render, staticRenderFns }